import type { Scan, ScanStatus, TargetListItem } from "@/api/client";

const IN_FLIGHT: ReadonlySet<ScanStatus> = new Set(["queued", "running"]);

function isInFlightStatus(status: ScanStatus): boolean {
  return IN_FLIGHT.has(status);
}

export function hasInFlightScan(target: TargetListItem): boolean {
  return target.recentScans.some((s) => isInFlightStatus(s.status));
}

export function anyScanInFlight(scans: Scan[]): boolean {
  return scans.some((s) => isInFlightStatus(s.status));
}
